import { render, staticRenderFns } from "./go_to_mhv.vue?vue&type=template&id=126a4918"
import script from "./go_to_mhv.vue?vue&type=script&lang=js"
export * from "./go_to_mhv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports